import { render, staticRenderFns } from "./BlockDisplay.vue?vue&type=template&id=344115c8"
import script from "./BlockDisplay.vue?vue&type=script&lang=js"
export * from "./BlockDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports